import {Component, OnInit, OnDestroy, Input} from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';

import { emailValidator, percentValidator, validatorPhone, spacesValidator } from '../../shared/custom-validators';
import { DataService } from '../../data.service';
import { FormErrorsService } from '../../form-errors.service';
import { Subscription } from 'rxjs/Subscription';

import { cancelSubscription } from '../../shared/cancelSubscription';

@Component({
    selector: 'app-person',
    templateUrl: './add-contact.component.html',
    styleUrls: ['./add-contact.component.scss']
})
export class AddContactComponent implements OnInit, OnDestroy {
    public formNewCompany: FormGroup;
    public isLoading: Boolean = false;
    public loginStatus;
    public error: Boolean = false;
    private subscription1: Subscription;
    @Input() private inputData;
    @Input() private isNewRegistration;

    public formErrors = {
        'name': '',
        'email': '',
        'phone': '',
        'location': '',
        'companyType': ''
    };

    constructor(public activeModal: NgbActiveModal,
                private fb: FormBuilder,
                private dataService: DataService,
                private formErrorsService: FormErrorsService) {
    }

    ngOnInit() {
        this.buildForm();
    }

    public buildForm() {
        this.formNewCompany = this.fb.group({
            name: [this.inputData ? this.inputData.name : '', [
                Validators.required,
                Validators.maxLength(70),
                spacesValidator,
                percentValidator
            ]],
            email: [this.inputData ? this.inputData.email : '', [
                Validators.required,
                Validators.maxLength(255),
                emailValidator,
                percentValidator
            ]],
            phone: [this.inputData ? this.inputData.phone : '', [
                Validators.required,
                Validators.minLength(11),
                Validators.maxLength(16)
            ]],
            location: [this.inputData ? this.inputData.location : '', [
                Validators.required,
                Validators.maxLength(175),
                spacesValidator,
                percentValidator
            ]],
            company_type: ['contractor']
        });

        this.subscription1 = this.formNewCompany.valueChanges
            .subscribe((data) => this.onValueChange());

        this.onValueChange();
    }

    ngOnDestroy(){
        cancelSubscription([this.subscription1]);
    }

    public onValueChange () {
        this.formErrors = this.formErrorsService.getErrors(this.formNewCompany, this.formErrors);
    }

    public validatePhone(event) {
        this.formNewCompany.get('phone').setValue(validatorPhone(event.target.value));
    }

    public onSubmit(form) {
        console.log(form.value);
        this.isLoading = true;
        this.dataService.newCompany(form.value)
            .subscribe((res) => {
                this.isLoading = false;
                if (res.status === 200) {
                    if (this.inputData) {

                    }
                    this.activeModal.close({type: 'success', data: form.value});
                }
            }, (err) => {
                this.isLoading = false;
                this.error = true;
                if (err.status === 500) {
                    this.loginStatus = 'Something went wrong!';
                }  else if (err.status === 422) {
                    this.activeModal.close({type: 'error'});
                }
                this.activeModal.close({type: 'error'});
            });
    }


    public sendByEnter(event, form) {
        if (event.keyCode === 13 && form.valid) {
            this.onSubmit(form);
        }
    }
}



// WEBPACK FOOTER //
// C:/www/onetouchSuperAdmin/src/app/shared/add-contact-modal/add-contact.component.ts